import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EmptyBadgesPlaceholder = () => {
  const { t } = useTranslation(['badges']);

  return (
    <Paper elevation={0} sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="subtitle1">
        {t('badges:management.badges.noData')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('badges:management.badges.createFirstBadge')}
      </Typography>
    </Paper>
  );
};

export default EmptyBadgesPlaceholder;
